module.exports = __webpack_public_path__ + "static/img/logo.381d6a3e.png";